<template>
  <div class="home">
    <!--HelloWorld msg="Welcome to Your YTbioad App"/-->
    <v-container>
      <br/>
      <br/>
      <br/>
      <v-row>
        <v-spacer/>
        <v-img src="@/assets/music.svg" heigth="25%" width="25%"/>
        <v-spacer/>
      </v-row>
      <br/>
      <br/>
      <v-row>
        <v-spacer/>
        <v-flex xs12 md5 ma-5>
          <v-btn
            color="primary"
            block
            x-large
            dark
            to="/apple"
          >
            AppleMusic
          </v-btn>
        </v-flex>
        <v-spacer/>
        <v-flex xs12 md5 ma-5>
          <v-btn
            color="primary"
            x-large
            block
            dark
            @click="loginToSpotify()"
          >
            Spotify
          </v-btn>
        </v-flex>
        <v-spacer/>
      </v-row>   
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Home',
  data: () => ({
    loginWindow: null,
  }),
  computed: {
    ...mapState('SpotifyModule', ['token'])
  },
  methods: {
    async loginToSpotify() {
      if(this.token.length !== 0) {
        this.$router.push('/spotify');
        return;
      }
      const URL = await this.$store.dispatch('SpotifyModule/GetLoginURL', ['user-top-read', 'user-follow-read']);
      let width = 500
      let height = 730
      let left = (screen.width / 2) - (width / 2)
      let top = (screen.height / 2) - (height / 2)
    
      window.addEventListener("storage", event => {
        if(event.key !== "message" || !event.newValue) return;
        const data = JSON.parse(event.newValue);
        this.$store.commit('SpotifyModule/SET_TOKEN', data.access_token);
        this.$router.push('/spotify');
      });

      window.open(URL,
        'Spotify',
        'menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left
      );
    }
  }
}
</script>